const cache = new Map()

export const CacheService = {
  get(key) {
    return cache.get(key) ?? null
  },

  set(key, value) {
    cache.set(key, value)
  },

  has(key) {
    return cache.has(key)
  },

  clear() {
    cache.clear()
  },
}
